import { useCallback } from "react";
import {
  LSQ_ACTIVITY_CODES,
  useGeniusLsqActivityMutation
} from "../../store/genius/geniusMarketing.api";
import {
  buildBrochureLsqPayload,
  buildSchoolLsqPayload,
  buildStudentLsqPayload
} from "./leadCaptureUtils";

export const useGeniusLeadCapture = () => {
  const [geniusLsqActivity] = useGeniusLsqActivityMutation();

  const pushLsq = useCallback(
    async (activity_code, payload) => {
      try {
        const result = await geniusLsqActivity({ activity_code, payload }).unwrap();
        return { success: true, data: result };
      } catch (error) {
        console.error("[Genius LSQ] activity failed:", error);
        return { success: false, error };
      }
    },
    [geniusLsqActivity]
  );

  const submitStudentRegistrationLead = useCallback(
    async ({ phone, firstName, lastName, grade, gradeId, schoolName, state, city }) => {
      const payload = buildStudentLsqPayload({
        phone,
        firstName,
        lastName,
        grade,
        gradeId,
        schoolName,
        state,
        city
      });

      return pushLsq(LSQ_ACTIVITY_CODES.STUDENT_REGISTRATION, payload);
    },
    [pushLsq]
  );

  const submitSchoolRegistrationLead = useCallback(
    async ({ phone, firstName, lastName, email, role, name, school, city, state }) => {
      const payload = buildSchoolLsqPayload({
        phone,
        firstName,
        lastName,
        email,
        role,
        name,
        school,
        city,
        state
      });

      return pushLsq(LSQ_ACTIVITY_CODES.SCHOOL_REGISTRATION, payload);
    },
    [pushLsq]
  );

  const submitBrochureLead = useCallback(
    async ({ phone, firstName, lastName, email, role, school, state, activityCode }) => {
      const code = activityCode ?? LSQ_ACTIVITY_CODES.BROCHURE_DOWNLOAD;
      const payload = buildBrochureLsqPayload({
        phone,
        firstName,
        lastName,
        email,
        role,
        school,
        state,
        activityCode: code
      });

      return pushLsq(code, payload);
    },
    [pushLsq]
  );

  return {
    submitStudentRegistrationLead,
    submitSchoolRegistrationLead,
    submitBrochureLead,
    submitGetInTouchLead: async () => ({ success: false, disabled: true })
  };
};
